import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const userService = {
    getAll,
    show,
};

const MODULE = {
    USER: 'users',
};

const API_URL = API.BASE_URL_API + '/v1/fe';

export function getAll (filter) {
    const request = {
        params: {
            company_uuid: filter?.companyUUID,
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.USER}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.USER}/${uuid}`);
}